import { createAction, props } from '@ngrx/store';
import { WorkstockAnalysisEntry } from '../workstock-analysis/WorkstockAnalysisEntry';
import { WorkstockMultipleCCDCSuccessorsEntry } from '../workstock-analysis/WorkstockMultipleSuccessorsEntry';
import { WorkstockCountermeasuresEntry } from '../workstock-countermeasures/WorkstockCountermeasuresEntry';
import { WorkstockSupplierAnalysisEntry } from '../workstock-supplier-analysis/WorkstockSupplierAnalysisEntry';
import { WorkstockSupplierAnalysisBmwEntry } from '../workstock-supplier-analysis-bmw/WorkstockSupplierAnalysisBmwEntry';
import { WorkstockSubCounters } from '../WorkstockSubCounters';
import { WorkstockFavoriteAnalysisEntry } from '../workstock-favorite-analysis/WorkstockFavoriteAnalysisEntry';
import { AnalysisType } from '../../analysis/models/AnalysisType';

export enum ActionTypes {
    GET_WORKSTOCK_MULTIPLE_CCDC_SUCCESSORS = '[Workstock Analysis Page] Loading workstock entries for the multiple PlantCCDC successors table',
    GET_WORKSTOCK_MULTIPLE_CCDC_SUCCESSORS_SUCCESS = '[Workstock API] Workstock entries for the multiple PlantCCDC successors table were fetched successfully',
    GET_WORKSTOCK_MULTIPLE_CCDC_SUCCESSORS_FAIL = '[Workstock API] Workstock entries for the multiple PlantCCDC successors table fetching failed',
    CONFIRM_CCDC_SUCCESSORS = '[Workstock Analysis Page] Confirming workstock multiple PlantCCDC successors of analysis',
    CONFIRM_CCDC_SUCCESSORS_SUCCESS = '[Workstock API] Confirming workstock multiple PlantCCDC successors of analysis successfully',
    CONFIRM_CCDC_SUCCESSORS_FAIL = '[Workstock API] Confirming workstock multiple PlantCCDC successors of analysis failed',
    SET_CCDC_SUCCESSORS = '[Workstock Analysis Page] Setting workstock multiple PlantCCDC successors of analysis',
    SET_CCDC_SUCCESSORS_SUCCESS = '[Workstock API] Setting workstock multiple PlantCCDC successors of analysis successfully',
    SET_CCDC_SUCCESSORS_FAIL = '[Workstock API] Setting workstock multiple PlantCCDC successors of analysis failed',
    OPEN_CCDC_SUCCESSORS_POPUP = '[Workstock Analysis Page] Opening CCDC Successors popup',
    CLOSE_CCDC_SUCCESSORS_POPUP = '[Workstock Analysis Page] Closing CCDC Successors popup',
    GET_WORKSTOCK_INCOMPLETE_FULL_ANALYSIS_SUCCESS = '[Workstock API] Workstock incomplete full analysis fetched successfully.',
    GET_WORKSTOCK_INCOMPLETE_FULL_ANALYSIS_FAIL = '[Workstock API] Workstock incomplete full analysis failed.',
    GET_WORKSTOCK_INCOMPLETE_ITO_ANALYSIS_SUCCESS = '[Workstock API] Workstock incomplete ItO analysis fetched successfully.',
    GET_WORKSTOCK_INCOMPLETE_ITO_ANALYSIS_FAIL = '[Workstock API] Workstock incomplete ItO analysis failed.',
    GET_WORKSTOCK_ANALYSIS_TO_BE_CONFIRMED_SUCCESS = '[Workstock API] Workstock entries for analysis to be confirmed table were fetched successfully',
    GET_WORKSTOCK_ANALYSIS_TO_BE_CONFIRMED_FAIL = '[Workstock API] Workstock entries for analysis to be confirmed table fetching failed',
    GET_WORKSTOCK_TIME_CRITICAL_COUNTERMEASURES_SUCCESS = '[Workstock API] Workstock time critical countermeasures fetched successfully.',
    GET_WORKSTOCK_TIME_CRITICAL_COUNTERMEASURES_FAIL = '[Workstock API] Workstock time critical countermeasures failed.',
    GET_WORKSTOCK_OPEN_COUNTERMEASURES_SUCCESS = '[Workstock API] Workstock open countermeasures fetched successfully',
    GET_WORKSTOCK_OPEN_COUNTERMEASURES_FAIL = '[Workstock API] Workstock open countermeasures failed',
    GET_SUPPLIER_ANALYSIS_TO_BE_HANDED_OVER = '[Workstock Supplier Page] Loading workstock supplier analysis to be handed over.',
    GET_SUPPLIER_ANALYSIS_TO_BE_HANDED_OVER_SUCCESS = '[Workstock API] Workstock supplier analysis to be handed over fetched successfully',
    GET_SUPPLIER_ANALYSIS_TO_BE_HANDED_OVER_FAIL = '[Workstock API] Workstock supplier analysis to be handed over failed',
    GET_SUPPLIER_ANALYSIS_HANDED_OVER = '[Workstock Supplier Page] Loading workstock supplier analysis handed over.',
    GET_SUPPLIER_ANALYSIS_HANDED_OVER_SUCCESS = '[Workstock API] Workstock supplier analysis handed over fetched successfully',
    GET_SUPPLIER_ANALYSIS_HANDED_OVER_FAIL = '[Workstock API] Workstock supplier analysis handed over failed',
    GET_SUPPLIER_ANALYSIS_DECLINED = '[Workstock Supplier Page] Loading workstock supplier analysis declined',
    GET_SUPPLIER_ANALYSIS_DECLINED_SUCCESS = '[Workstock API] Workstock supplier analysis declined fetched successfully',
    GET_SUPPLIER_ANALYSIS_DECLINED_FAIL = '[Workstock API] Workstock supplier analysis declined failed',
    GET_SUPPLIER_ANALYSIS_TO_BE_CONFIRMED_BMW_SUCCESS = '[Workstock API] Workstock supplier analysis to be confirmed (bmw) fetched successfully',
    GET_SUPPLIER_ANALYSIS_TO_BE_CONFIRMED_BMW_FAIL = '[Workstock API] Workstock supplier analysis to be confirmed (bmw) failed',
    GET_SUPPLIER_ANALYSIS_DECLINED_BMW_SUCCESS = '[Workstock API] Workstock supplier analysis declined (bmw) fetched successfully',
    GET_SUPPLIER_ANALYSIS_DECLINED_BMW_FAIL = '[Workstock API] Workstock supplier analysis declined (bmw) failed',
    GET_WORKSTOCK_SUB_COUNTERS_SUCCESS = '[Workstock Counter API] Workstock sub counters loaded successfully',
    GET_WORKSTOCK_SUB_COUNTERS_FAIL = '[Workstock Counter API] Failed to load workstock sub counters',
    LOAD_WORKSTOCK_COMPONENT = '[Workstock Component] Started loading the workstock component.',
    LOAD_WORKSTOCK_SUB_COUNTERS = '[Workstock Component] Started loading the workstock sub counters.',
    LOAD_WORKSTOCK_SUPPLIER_ANALYSIS_COMPONENT = '[Workstock supplier analysis Component] Started loading the workstock supplier analysis component.',
    LOAD_WORKSTOCK_ANALYSIS_COMPONENT = '[Workstock analysis Component] Started loading the workstock analysis component.',
    LOAD_WORKSTOCK_COUNTERMEASURES_COMPONENT = '[Workstock countermeasures Component] Started loading the workstock countermeasures component.',
    LOAD_WORKSTOCK_SUPPLIER_COMPONENT = '[Workstock supplier Component] Started loading the workstock supplier component.',
    LOAD_WORKSTOCK_FAVORITE_ANALYSIS = '[Workstock favorites analysis Component] Started loading the workstock favorite analysis.',
    GET_WORKSTOCK_FAVORITE_ANALYSIS_SUCCESS = '[Workstock API] Workstock favorite analysis fetched successfully',
    GET_WORKSTOCK_FAVORITE_ANALYSIS_FAIL = '[Workstock API] Workstock favorite analysis failed',
    REMOVE_FROM_FAVORITES = '[Workstock API] Removing analysis from favorites',
    REMOVE_FROM_FAVORITES_SUCCESS = '[Workstock API] Analysis removed from favorites successfully',
    REMOVE_FROM_FAVORITES_FAIL = '[Workstock API] Analysis removed from favorites failed',
    OPEN_ANALYSIS_IN_NEW_TAB = '[Workstock] Open analysis in new tab',
    OPEN_ANALYSIS_LATEST = '[Workstock] Open analysis latest version'
}

export const getWorkstockMultipleCCDCSuccessors = createAction(ActionTypes.GET_WORKSTOCK_MULTIPLE_CCDC_SUCCESSORS);

export const getWorkstockMultipleCCDCSuccessorsSuccess = createAction(
    ActionTypes.GET_WORKSTOCK_MULTIPLE_CCDC_SUCCESSORS_SUCCESS,
    props<{ workstockMultipleCCDCSuccessors: WorkstockMultipleCCDCSuccessorsEntry[] }>()
);

export const getWorkstockMultipleCCDCSuccessorsFail = createAction(ActionTypes.GET_WORKSTOCK_MULTIPLE_CCDC_SUCCESSORS_FAIL);

export const confirmCCDCSuccessors = createAction(ActionTypes.CONFIRM_CCDC_SUCCESSORS, props<{ workstockAnalysis: WorkstockMultipleCCDCSuccessorsEntry }>());

export const confirmCCDCSuccessorsSuccess = createAction(ActionTypes.CONFIRM_CCDC_SUCCESSORS_SUCCESS, props<{ analysisId: number }>());

export const confirmCCDCSuccessorsFail = createAction(ActionTypes.CONFIRM_CCDC_SUCCESSORS_FAIL);

export const setCCDCSuccessors = createAction(ActionTypes.SET_CCDC_SUCCESSORS, props<{ workstockAnalysis: WorkstockMultipleCCDCSuccessorsEntry }>());

export const setCCDCSuccessorsSuccess = createAction(ActionTypes.SET_CCDC_SUCCESSORS_SUCCESS);

export const setCCDCSuccessorsFail = createAction(ActionTypes.SET_CCDC_SUCCESSORS_FAIL);

export const openCCDCSuccessorsPopup = createAction(ActionTypes.OPEN_CCDC_SUCCESSORS_POPUP);

export const closeCCDCSuccessorsPopup = createAction(ActionTypes.CLOSE_CCDC_SUCCESSORS_POPUP);

export const getWorkstockIncompleteFullAnalysisSuccess = createAction(
    ActionTypes.GET_WORKSTOCK_INCOMPLETE_FULL_ANALYSIS_SUCCESS,
    props<{ analysis: WorkstockAnalysisEntry[] }>()
);

export const getWorkstockIncompleteFullAnalysisFail = createAction(ActionTypes.GET_WORKSTOCK_INCOMPLETE_FULL_ANALYSIS_FAIL);

export const getWorkstockIncompleteItoAnalysisSuccess = createAction(
    ActionTypes.GET_WORKSTOCK_INCOMPLETE_ITO_ANALYSIS_SUCCESS,
    props<{ workstockIncompleteItoAnalysis: WorkstockAnalysisEntry[] }>()
);

export const getWorkstockIncompleteItoAnalysisFail = createAction(ActionTypes.GET_WORKSTOCK_INCOMPLETE_ITO_ANALYSIS_FAIL);

export const getWorkstockAnalysisToBeConfirmedSuccess = createAction(
    ActionTypes.GET_WORKSTOCK_ANALYSIS_TO_BE_CONFIRMED_SUCCESS,
    props<{ workstockAnalysisToBeConfirmed: WorkstockAnalysisEntry[] }>()
);

export const getWorkstockAnalysisToBeConfirmedFail = createAction(ActionTypes.GET_WORKSTOCK_ANALYSIS_TO_BE_CONFIRMED_FAIL);

export const getWorkstockTimeCriticalCountermeasuresSuccess = createAction(
    ActionTypes.GET_WORKSTOCK_TIME_CRITICAL_COUNTERMEASURES_SUCCESS,
    props<{ workstockTimeCriticalCountermeasures: WorkstockCountermeasuresEntry[] }>()
);

export const getWorkstockTimeCriticalCountermeasuresFail = createAction(ActionTypes.GET_WORKSTOCK_TIME_CRITICAL_COUNTERMEASURES_FAIL);

export const getWorkstockOpenCountermeasuresSuccess = createAction(
    ActionTypes.GET_WORKSTOCK_OPEN_COUNTERMEASURES_SUCCESS,
    props<{ workstockOpenCountermeasures: WorkstockCountermeasuresEntry[] }>()
);

export const getWorkstockOpenCountermeasuresFail = createAction(ActionTypes.GET_WORKSTOCK_OPEN_COUNTERMEASURES_FAIL);

export const getWorkstockSupplierAnalysisToBeHandedOver = createAction(ActionTypes.GET_SUPPLIER_ANALYSIS_TO_BE_HANDED_OVER);

export const getWorkstockSupplierAnalysisToBeHandedOverSuccess = createAction(
    ActionTypes.GET_SUPPLIER_ANALYSIS_TO_BE_HANDED_OVER_SUCCESS,
    props<{ workstockSupplierAnalysisToBeHandedOver: WorkstockSupplierAnalysisEntry[] }>()
);

export const getWorkstockSupplierAnalysisToBeHandedOverFail = createAction(ActionTypes.GET_SUPPLIER_ANALYSIS_TO_BE_HANDED_OVER_FAIL);

export const getWorkstockSupplierAnalysisHandedOver = createAction(ActionTypes.GET_SUPPLIER_ANALYSIS_HANDED_OVER);

export const getWorkstockSupplierAnalysisHandedOverSuccess = createAction(
    ActionTypes.GET_SUPPLIER_ANALYSIS_HANDED_OVER_SUCCESS,
    props<{ workstockSupplierAnalysisHandedOver: WorkstockSupplierAnalysisEntry[] }>()
);

export const getWorkstockSupplierAnalysisHandedOverFail = createAction(ActionTypes.GET_SUPPLIER_ANALYSIS_HANDED_OVER_FAIL);

export const getWorkstockSupplierAnalysisDeclined = createAction(ActionTypes.GET_SUPPLIER_ANALYSIS_DECLINED);

export const getWorkstockSupplierAnalysisDeclinedSucess = createAction(
    ActionTypes.GET_SUPPLIER_ANALYSIS_DECLINED_SUCCESS,
    props<{ workstockSupplierAnalysisDeclined: WorkstockSupplierAnalysisEntry[] }>()
);

export const getWorkstockSupplierAnalysisDeclinedFail = createAction(ActionTypes.GET_SUPPLIER_ANALYSIS_DECLINED_FAIL);

export const getWorkstockSupplierAnalysisToBeConfirmedBmwSuccess = createAction(
    ActionTypes.GET_SUPPLIER_ANALYSIS_TO_BE_CONFIRMED_BMW_SUCCESS,
    props<{ workstockSupplierAnalysisToBeConfirmedBmw: WorkstockSupplierAnalysisBmwEntry[] }>()
);

export const getWorkstockSupplierAnalysisToBeConfirmedBmwFail = createAction(ActionTypes.GET_SUPPLIER_ANALYSIS_TO_BE_CONFIRMED_BMW_FAIL);

export const getWorkstockSupplierAnalysisDeclinedBmwSuccess = createAction(
    ActionTypes.GET_SUPPLIER_ANALYSIS_DECLINED_BMW_SUCCESS,
    props<{ workstockSupplierAnalysisDeclinedBmw: WorkstockSupplierAnalysisBmwEntry[] }>()
);

export const getWorkstockSupplierAnalysisDeclinedBmwFail = createAction(ActionTypes.GET_SUPPLIER_ANALYSIS_DECLINED_BMW_FAIL);

export const getWorkstockSubCountersSuccess = createAction(
    ActionTypes.GET_WORKSTOCK_SUB_COUNTERS_SUCCESS,
    props<{ workstockSubCounters: WorkstockSubCounters }>()
);

export const getWorkstockSubCountersFail = createAction(ActionTypes.GET_WORKSTOCK_SUB_COUNTERS_FAIL);

export const loadWorkstockComponent = createAction(ActionTypes.LOAD_WORKSTOCK_COMPONENT);

export const loadWorkstockSubCounters = createAction(ActionTypes.LOAD_WORKSTOCK_SUB_COUNTERS);

export const loadWorkstockSupplierAnalysisComponent = createAction(ActionTypes.LOAD_WORKSTOCK_SUPPLIER_ANALYSIS_COMPONENT);

export const loadWorkstockAnalysisComponent = createAction(ActionTypes.LOAD_WORKSTOCK_ANALYSIS_COMPONENT);

export const loadWorkstockCounterMeasuresComponent = createAction(ActionTypes.LOAD_WORKSTOCK_COUNTERMEASURES_COMPONENT);

export const loadWorkstockSupplierBMWComponent = createAction(ActionTypes.LOAD_WORKSTOCK_SUPPLIER_COMPONENT);

export const loadWorkstockFavoriteAnalysis = createAction(ActionTypes.LOAD_WORKSTOCK_FAVORITE_ANALYSIS);

export const getWorkstockFavoriteAnalysisSuccess = createAction(
    ActionTypes.GET_WORKSTOCK_FAVORITE_ANALYSIS_SUCCESS,
    props<{ analysis: WorkstockFavoriteAnalysisEntry[] }>()
);

export const getWorkstockFavoriteAnalysisFail = createAction(ActionTypes.GET_WORKSTOCK_FAVORITE_ANALYSIS_FAIL);

export const removeFavoriteAnalysis = createAction(ActionTypes.REMOVE_FROM_FAVORITES, props<{ analysisKey: string }>());

export const removeFavoriteAnalysisSuccess = createAction(ActionTypes.REMOVE_FROM_FAVORITES_SUCCESS, props<{ analysisKey: string }>());

export const removeFavoriteAnalysisFail = createAction(ActionTypes.REMOVE_FROM_FAVORITES_FAIL);

export const openAnalysisInNewTab = createAction(
    ActionTypes.OPEN_ANALYSIS_IN_NEW_TAB,
    props<{ analysisKey: string; version: number; analysisType?: AnalysisType }>()
);

export const openAnalysisLatest = createAction(ActionTypes.OPEN_ANALYSIS_LATEST, props<{ analysisKey: string; analysisType?: AnalysisType }>());
